import * as React from 'react';

function SvgNavigationSecondary(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17 7a2 2 0 11-4 0 2 2 0 014 0zm0 7.2a2 2 0 11-4 0 2 2 0 014 0zm-2 9.2a2 2 0 100-4 2 2 0 000 4z"
        fill="#414B56"
      />
    </svg>
  );
}

export default SvgNavigationSecondary;
